/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useMemo } from "react";
import { useSearchParams } from 'react-router';

const DEFAULT_PAGE_SIZE = String(10);

export type PaginationGetParams = {
  page: string;
  limit: string;
};

type SetPaginationGetParams = (params: Partial<PaginationGetParams>) => void;

/**
 * usePagination function.
 *
 * @returns {*} Return value description
 */
export function usePagination(): [PaginationGetParams, SetPaginationGetParams] {
  const [searchParams, setSearchParams] = useSearchParams();

  const pagination = useMemo(() => ({
    page: searchParams.get("page") ?? "1",
    limit: searchParams.get("pageSize") ?? DEFAULT_PAGE_SIZE,
  }), [searchParams]);

  const setPagination: SetPaginationGetParams = (newPagination) => {
    setSearchParams((previous) => ({ ...previous, ...newPagination }));
  };

  return [pagination, setPagination];
}
